/* eslint-disable no-param-reassign */

import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['back'];

  connect() {
    if (window.getComputedStyle(this.backTarget).display !== 'none') {
      const crumbs = this.element.querySelectorAll('.crumb');

      const showI = crumbs.length - 2;

      crumbs.forEach((crumb, i) => {
        if (i !== showI) {
          crumb.style.display = 'none';
        } else {
          crumb.style.display = 'inline-block';
          crumb.classList.remove('d-none');
        }
      });
    }
  }
}
